/**
 * Primeiro elemento focavel de cada pagina
 * (docs/LGPD-E-ACESSIBILIDADE.md, secao 8).
 *
 * O destino e `#conteudo`, que e o id do <main> de todas as telas. Antes
 * apontava para `#main-content`, que NAO existia em nenhuma delas: o link focava
 * o nada, e o axe nao acusa porque o href aponta para algo. Corrigido no
 * Prompt 6, com o teste de acessibilidade cobrindo o alvo.
 */
export function SkipToContent() {
  return (
    <a
      href="#conteudo"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-9999 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-lg focus:outline-hidden focus:ring-2 focus:ring-ring"
    >
      Pular para o conteúdo principal
    </a>
  );
}
